import classNames from 'classnames';
import { Map } from 'immutable';
import React from 'react';

import { SELECTORS } from '../../../../../../../../../constants';
import TextSearch from '../../../../../../../../common/TextSearch';
import * as perspectives from '../../../../../constants/perspectives';
import LargeHeroContainer from './LargeHeroContainer';

import styles from './LargeHero.less';

const perspectiveMappings = Map({
  [perspectives.DISCOVER]: Map({
    className: styles.discoverHero,
    textSearchMode: 'hero',
  }),
  [perspectives.SEARCH]: Map({ className: styles.searchHero, textSearchMode: 'header' }),
});

type LargeHeroPropTypes = {
  discoverHeading: string;
  query: string;
  perspective: perspectives.PerspectiveType;
  onChangeQuery: (...args) => void;
  onClick: (...args) => void;
};

const LargeHero = (props: LargeHeroPropTypes) => {
  return (
    <div className={styles.largeHeroWrapper}>
      <div className={styles.largeHeroInnerWrapper}>
        <div className={styles.textSearchContainer}>
          <div
            className={classNames([
              styles.textSearch,
              perspectiveMappings.getIn([props.perspective, 'className']),
            ])}
          >
            <TextSearch
              focusOnMount={props.perspective === perspectives.DISCOVER}
              query={props.query}
              onChange={props.onChangeQuery}
              mode={perspectiveMappings.getIn([props.perspective, 'textSearchMode'])}
              name={SELECTORS.INPUT_NAME_HEADER_SEARCH_BOX}
              onClick={props.onClick}
            />
          </div>
        </div>
        <LargeHeroContainer
          discoverHeading={props.discoverHeading}
          perspective={props.perspective}
        />
      </div>
    </div>
  );
};

export default LargeHero;
